let audioCtx: AudioContext | null = null;

function getCtx(): AudioContext {
  if (!audioCtx) {
    audioCtx = new AudioContext();
  }
  return audioCtx;
}

function playTone(freq: number, duration: number, type: OscillatorType = 'square', volume: number = 0.1): void {
  try {
    const ctx = getCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.value = volume;
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch {
    // Audio might not be available
  }
}

export function playChopSound(): void {
  playTone(200, 0.1, 'square', 0.08);
  setTimeout(() => playTone(250, 0.08, 'square', 0.06), 50);
}

export function playBoopSound(): void {
  playTone(600, 0.15, 'sine', 0.1);
  setTimeout(() => playTone(800, 0.1, 'sine', 0.08), 80);
  setTimeout(() => playTone(1000, 0.08, 'sine', 0.06), 140);
}

export function playCoinSound(): void {
  playTone(880, 0.1, 'sine', 0.08);
  setTimeout(() => playTone(1100, 0.15, 'sine', 0.07), 80);
}

export function playBuildSound(): void {
  playTone(300, 0.1, 'square', 0.07);
  setTimeout(() => playTone(400, 0.1, 'square', 0.07), 100);
  setTimeout(() => playTone(500, 0.12, 'square', 0.07), 200);
}

export function playLevelUpSound(): void {
  playTone(400, 0.15, 'sine', 0.1);
  setTimeout(() => playTone(500, 0.15, 'sine', 0.1), 120);
  setTimeout(() => playTone(600, 0.15, 'sine', 0.1), 240);
  setTimeout(() => playTone(800, 0.25, 'sine', 0.12), 360);
}

export function playThrowSound(): void {
  playTone(400, 0.08, 'sawtooth', 0.06);
  playTone(500, 0.12, 'sawtooth', 0.04);
}

export function playSellSound(): void {
  playCoinSound();
  setTimeout(() => playTone(1200, 0.1, 'sine', 0.06), 150);
}

export function resumeAudio(): void {
  if (audioCtx && audioCtx.state === 'suspended') {
    audioCtx.resume();
  }
}
